import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestModel } from '../typings/typing';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  prefix = '/eshop_backend';
  constructor(private http: HttpClient) {}
  simulateOrder(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/salesOrder/simulate', params);
  }
  placeOrder(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/salesOrder/create', params);
  }
  // export Delivery History
  exportOrderDeliveryHistory(params: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get(this.prefix +'/orderItemDeliveryInfo/export', { headers, params, responseType: 'blob' });
  }
  // get delivery Data
  queryOrderDeliveryList(params: any) {
    return this.http.get<RequestModel>(this.prefix +'/orderItemDeliveryInfo/page', { params });
  }
  //
  queryOrderDeliveryStatistics() {
    return this.http.get<RequestModel>(this.prefix +'/orderItemDeliveryInfo/statistics');
  }

  queryOrderHistoryStatistics() {
    return this.http.get<RequestModel>(this.prefix +'/orderInfo/statistics');
  }
  
  // get Financial Data
  queryFinancialData(params: any) {
    return this.http.get<RequestModel>(this.prefix +'/financial/page', {params});
  }
   // export Financial Data
   queryInvoiceData(params: any) {
    return this.http.get<RequestModel>(this.prefix +'/invoice/page', {params});
  }
  //get credit limit
  getCreditLimit() {
    return this.http.get<RequestModel>(this.prefix +'/creditLimit/get', {});
  }
  //item list
  queryItemData(params: any) {
    return this.http.get<RequestModel>(this.prefix +'/orderItemInfo/page', {params});
  }
  //order list
  queryOrderData(params: any) {
    return this.http.get<RequestModel>(this.prefix +'/orderInfo/page', {params});
  }
  //cancel order
  cancelOrder(params: any){
    const headers = new HttpHeaders().set('globalLoading', 'true');
    return this.http.post<RequestModel>(this.prefix +'/salesOrder/cancel', params,{ headers });
  }
  //cancel item
  cancelItem(params: any){
    const headers = new HttpHeaders().set('globalLoading', 'true');
    return this.http.post<RequestModel>(this.prefix +'/salesOrder/cancelItem', params,{ headers });
  }
}
